var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Type } from './Type';
import { Int } from './Int';
var Bitmap = /** @class */ (function (_super) {
    __extends(Bitmap, _super);
    function Bitmap() {
        var _this = _super.call(this) || this;
        _this._int = new Int(0);
        return _this;
    }
    Bitmap.prototype.encodeBuffer = function (value, buffer) {
        if (DEVELOPMENT && value.length > 52) {
            throw new Error('Maximum bitmap length is 52. For more use Binary.BigBitmap.');
        }
        var number = 1;
        for (var i = 0; i < value.length; i++) {
            number = number * 2 + (value[i] ? 1 : 0);
        }
        this._int.encodeBuffer(number, buffer);
    };
    Bitmap.prototype.decodeBuffer = function (buffer) {
        var number = this._int.decodeBuffer(buffer);
        var value = [];
        while (number > 1) {
            value.unshift(Boolean(number % 2));
            number = Math.floor(number / 2);
        }
        return value;
    };
    return Bitmap;
}(Type));
export { Bitmap };
